// LIST
export const FETCH_HISTORYS = "app/History/FETCH_HISTORYS";
export const FETCH_HISTORYS_SUCCESS = "app/History/FETCH_HISTORYS_SUCCESS";
export const FETCH_HISTORYS_FAILURE = "app/History/FETCH_HISTORYS_FAILURE";
